export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10742.d77f7318.jpg";